export default class AdminLicenciaNoNotificadasLista {

    /**
     *
     * @param {Array} props.grados
     * @param {Array} props.secciones
     */
    constructor(props) {
        $('#empresa_ids').select2();

        $('.btn-editar').click(function () {
            let id = this.parentNode.dataset.id;
            let formModal = new AdminLicenciaActivadaForm({grados: props.grados, secciones: props.secciones});
            formModal.editar(id, {
                onSuccess: function() {
                    window.location.reload();
                }
            });
        });

        $('.btn-editar-empresa').click(function() {
            let form = new AdminEmpresaForm();
            form.editar(this.dataset.id, {
                onSuccess: function(response) {
                    window.location.reload();
                }
            });
        });

        $('#btn-limpiar').click(function () {
            window.location.href = window.location.origin + window.location.pathname;
        });

        $('#btn-buscar').click(function () {
            window.location.href = window.location.origin + window.location.pathname + '?' + $('#form-buscar').serialize();
        });

        $('.btn-enviar-correo').click(function () {
            let id = this.parentNode.dataset.id;
            let respuesta = window.confirm('¿Enviar correo?');
            if (respuesta) {
                let btn = this;
                btn.disabled = true;
                Licencia.enviarCorreo(id, {
                    then: function (response) {
                        window.alert(response.data.message);
                    },
                    fail: function (error) {
                        window.alert(error.response.data.message);
                    },
                    always: function () {
                        btn.disabled = false
                    },
                });
            }
        });

        $('#btn-exportar').click(function () {
            window.location.href = window.location.origin + '/admin/licencias/no-notificadas-excel?' + $('#form-buscar').serialize();
        });
    }
}
